import React from 'react'

function NoBookingsFound() {
  return (
    <div>
      <div className='d-flex justify-content-center align-items-center' style={{marginTop:'200px', marginBottom:'200px'}}>
      <h1 style={{justifyContent:'center'}}>No Bookings Found</h1>
    </div>
    </div>
  )
}

export default NoBookingsFound
